import { graphql } from 'services/api';
import * as queries from './queries';
import * as mutations from './mutations';
import {
  AutomationTask,
  CreateAutomationTaskInput,
  DeleteAutomationTaskInput,
  UpdateAutomationTaskInput
} from './types';

export const getAutomationTasksByCampaignId = async ({
  campaignId
}: {
  campaignId: string;
}): Promise<AutomationTask[]> => {
  const response = await graphql.query(queries.getAutomationTasksByCampaignId, {
    campaignId,
    limit: 50
  });

  return response.getAutomationTasksByCampaignId.items;
};

/**
 * @deprecated use generated graphql mutation
 */
export const createAutomationTask = async (
  input: CreateAutomationTaskInput
) => {
  const response = await graphql.mutation(
    mutations.createAutomationTask,
    input
  );

  return response.createAutomationTask;
};

/**
 * @deprecated use generated graphql mutation
 */
export const updateAutomationTask = async (
  input: UpdateAutomationTaskInput
) => {
  const response = await graphql.mutation(
    mutations.updateAutomationTask,
    input
  );

  return response.updateAutomationTask;
};

/**
 * @deprecated use generated graphql mutation
 */
export const deleteAutomationTask = async (
  input: DeleteAutomationTaskInput
): Promise<void> => {
  await graphql.mutation(mutations.deleteAutomationTask, input);
};

export const campaignAutomationTasksSaved = async ({
  campaignId
}: {
  campaignId: string;
}): Promise<string> => {
  return graphql.mutation(mutations.campaignAutomationTasksSaved, {
    campaignId
  });
};

export const getAutomationTasksByCandidateBatchGroup = async ({
  candidateBatchGroupId
}: {
  candidateBatchGroupId: string;
}) => {
  const response = await graphql.query(
    queries.getAutomationTasksByCandidateBatchGroup,
    {
      candidateBatchGroupId
    }
  );

  return response.getAutomationTasksByCandidateBatchGroup.items;
};
